import styled, { css } from 'styled-components';

export const Base = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	margin: 8px 0;
	padding: 14px 16px;
	background-color: ${({ theme }) => theme.gray[100]};
	border: 1px solid ${({ theme }) => theme.gray[200]};
	border-radius: 10px;
`;

export const Title = styled.div`
	font-size: 12px;
	font-weight: 600;
	letter-spacing: 0.04em;
	text-transform: uppercase;
	color: ${({ theme }) => theme.gray[700]};
`;

export const Steps = styled.ol`
	display: flex;
	flex-direction: column;
	gap: 8px;
	margin: 0;
	padding: 0;
	list-style: none;
`;

export const Step = styled.li`
	display: flex;
	align-items: flex-start;
	gap: 10px;
	font-size: 13px;
	line-height: 1.4;
	color: ${({ theme }) => theme.gray[900]};
`;

export const StepIndex = styled.span`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	width: 20px;
	height: 20px;
	border-radius: 50%;
	background-color: ${({ theme }) => theme.gray[200]};
	color: ${({ theme }) => theme.gray[800]};
	font-size: 11px;
	font-weight: 600;
`;

export const StepLabel = styled.span`
	padding-top: 2px;
`;

export const ApproveButton = styled.button<{ $queued?: boolean }>`
	align-self: flex-start;
	padding: 6px 12px;
	border-radius: 18px;
	font-family: inherit;
	font-size: 12px;
	font-weight: 500;
	transition: background-color 0.15s ease, border-color 0.15s ease;

	${({ theme, $queued }) =>
		$queued
			? css`
					background-color: ${theme.gray[200]};
					color: ${theme.gray[700]};
					border: 1px solid ${theme.gray[200]};
			  `
			: css`
					background-color: ${theme.blue[500]};
					color: ${theme.gray[1000]};
					border: 1px solid ${theme.blue[500]};

					&:hover:not(:disabled) {
						background-color: ${theme.blue[600]};
						border-color: ${theme.blue[600]};
					}
			  `}

	&:disabled {
		background-color: ${({ theme }) => theme.gray[200]};
		border-color: ${({ theme }) => theme.gray[200]};
		color: ${({ theme }) => theme.gray[700]};
	}
`;

export const Approved = styled.div`
	align-self: flex-start;
	display: inline-flex;
	align-items: center;
	gap: 6px;
	padding: 4px 12px;
	font-size: 12px;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[600]};
`;

export const CheckIcon = styled.svg`
	width: 14px;
	height: 14px;
	flex-shrink: 0;
	color: ${({ theme }) => theme.green[600]};
`;
